import React from 'react';
import CamperMoreInfo from '../../component/CamperMoreInfo/CamperMoreInfo';
import { camperDetailsFordRoller266TL } from '../../constants/constantsCampers';
const CarCardFordRoller266TL = () => {
  return <CamperMoreInfo props={camperDetailsFordRoller266TL}></CamperMoreInfo>;
};

export default CarCardFordRoller266TL;
